import { render } from "./AdminDriverViewList.vue?vue&type=template&id=efd3f15e&scoped=true&ts=true&lang=true"
import script from "./AdminDriverViewList.vue?vue&type=script&lang=ts"
export * from "./AdminDriverViewList.vue?vue&type=script&lang=ts"

import "./AdminDriverViewList.vue?vue&type=style&index=0&id=efd3f15e&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd3f15e"]])

export default __exports__